export const flashcardDefaultContent = {
    en: {
        flashcardTexts: {
            frontOfCard: 'Front of Card',
            backOfCard: 'Back of Card',
        },
    },
    es: {
        flashcardTexts: {
            frontOfCard: 'Frente de la tarjeta',
            backOfCard: 'Reverso de la tarjeta',
        }
    }
}
